'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { IoMdArrowDropdown } from 'react-icons/io';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-end sm:max-w-[300px]',
        'ea-category-sort',
        className,
      )}
    >
      <div className={cn('w-full', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={t('text2355')}
            // placeholder={`${t('text341')}..`}
            innerTriggerClassName="px-6"
            className={cn(
              'relative h-14 w-full rounded-[8px] bg-[#f9fafb] px-0 text-sm font-normal text-black transition-all hover:bg-[#f9fafb]/50 lg:text-base',
              'ea-category-sort__select-trigger',
            )}
            expandIcon={<IoMdArrowDropdown size={20} className="text-primary" />}
          >
            <p className="absolute left-6 top-[8.5px] z-10 h-[17px] text-xs font-medium text-[#9e9e9e]">
              {t('text2355')}
            </p>
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('', 'ea-category-sort__select-value')}
            />
          </SelectTrigger>
          <SelectContent sideOffset={4} className={cn('', 'ea-category-sort__select-content')}>
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('px-5 text-sm', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
